import React from 'react';

// Components

import BlockWrapper from './BlockWrapper';

// Styles

import { darculaPagesTooltipStyles, darculaTheme } from '../darculaTheme';

const {
    blockWrapperAdditionalStyles,
    rowHoverBackground,
    rowDefaultBackground,
    currentPageHighlightBackground,
    titleStyle,
    rowBaseStyle,
    inactiveFlowTextColor,
    hhmBadgeOffsetStyle,
    pageNameOffsetStyle,
    componentNameOffsetStyle,
} = darculaPagesTooltipStyles;

const PagesTooltip = props => {
    const {
        adjustedFlow,
        changePage,
        id,
        page
    } = props;

    const handleMouseClick = pageIndex => changePage(pageIndex);

    return (
        <BlockWrapper
            id={ id }
            additionalStyles={ blockWrapperAdditionalStyles }
        >
            <div>
                <div style={ titleStyle }>
                    Pages and Components
                </div>
                {
                    adjustedFlow.map((el, idx) => {

                        const isCurrentPage = idx === page;

                        return (
                            <div
                                key={ `${el.pageName}_${idx}` }
                                style={{
                                    ...rowBaseStyle,
                                    color: el.isActive ? darculaTheme.fg : inactiveFlowTextColor,
                                    ...(isCurrentPage ? { backgroundColor: currentPageHighlightBackground } : {}),
                                }}
                                onClick={() => handleMouseClick(idx)}
                                onMouseEnter={ e => {
                                    e.currentTarget.style.backgroundColor = rowHoverBackground;
                                } }
                                onMouseLeave={ e => {
                                    e.currentTarget.style.backgroundColor = isCurrentPage
                                        ? currentPageHighlightBackground
                                        : rowDefaultBackground;
                                } }
                            >
                                <span>
                                    { `${el.sectionIndex + 1}_${idx}` }
                                </span>
                                <span style={ hhmBadgeOffsetStyle }>
                                    { el.hhm === -1 ? '' : <b>{ `[ ${el.hhm} ]` }</b> }
                                </span>
                                <span style={ pageNameOffsetStyle }>
                                    { el.pageName }
                                </span>
                                <span style={ componentNameOffsetStyle }>
                                    { el.componentName }
                                </span>
                            </div>
                        );
                    })
                }
            </div>
        </BlockWrapper>
    );
};

export default PagesTooltip;
